import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { cardReveal, fadeUp, Reveal, staggerContainer, viewportOnce } from "../common/Motion";

const stages = [
  ["01", "Understand", "Connect business data, documents, conversations, and operational context."],
  ["02", "Reason", "Apply fit-for-purpose models, rules, and retrieval to each decision."],
  ["03", "Act", "Trigger workflows across the systems your teams already depend on."],
  ["04", "Improve", "Measure outcomes, capture feedback, and continuously refine performance."],
];

const AIPlatform = () => {
  const reduceMotion = useReducedMotion();
  return <section className="section ai-platform-section" id="ai-platform">
    <div className="site-shell">
      <Reveal className="section-heading split-heading">
        <div><p className="eyebrow">The Visiosol AI layer</p><h2>Intelligence built into the way work gets done.</h2></div>
        <p>We do not bolt a chatbot onto an old process. We redesign the flow around trusted data, human judgment, and AI agents that can understand context and take useful action.</p>
      </Reveal>
      <div className="ai-platform-layout">
        <motion.div className="ai-system-map" aria-label="AI system connecting business knowledge to governed actions" variants={reduceMotion ? undefined : fadeUp} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
          <div className="ai-map-status"><span></span> Intelligence layer active</div>
          <div className="ai-map-inputs"><span>Business data</span><span>Documents</span><span>Customer signals</span></div>
          <div className="ai-map-core"><small>VISIOSOL</small><strong>AI</strong><span>Context · Reasoning · Orchestration</span></div>
          <div className="ai-map-outputs"><span>Decisions</span><span>Workflows</span><span>Experiences</span></div>
        </motion.div>
        <motion.div className="ai-stage-grid" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
          {stages.map(([number, title, copy]) => <motion.article variants={cardReveal} key={title}><span>{number}</span><h3>{title}</h3><p>{copy}</p></motion.article>)}
        </motion.div>
      </div>
      <Reveal className="ai-guardrail"><strong>AI with enterprise guardrails.</strong><span>Human oversight</span><span>Private data boundaries</span><span>Evaluation and monitoring</span><span>Secure integration</span></Reveal>
    </div>
  </section>;
};

export default AIPlatform;
